<template>
	<div class="bg-primary p-3 border mb-4">
		<h3 class="font-normal mb-4"><strong class="text-3 font-display">{{ plan.DisplayName }} <template v-if="isAnnual"><del class="text-disabled">${{ plan.MonthlyAmount }}</del> ${{ annualMonthlyPrice }}</template><template v-else>${{ plan.MonthlyAmount }}</template>/mo</strong> billed {{ isAnnual ? 'annually' : 'monthly' }}</h3>
		<ul class="b9:columns-2">
			<li class="flex items-baseline gap-3 mb-3">
				<Inline svg="check" class="w-icon h-icon text-icon-success self-center shrink-0" />
				{{ plan.UserLimit }} included users
			</li>
			<li v-if="plan.AllowGuests" class="flex items-baseline gap-3 mb-3">
				<Inline svg="check" class="w-icon h-icon text-icon-success self-center shrink-0" />
				{{ plan.IncludedGuests }} included guests
			</li>
			<li class="flex items-baseline gap-3 mb-3">
				<Inline svg="check" class="w-icon h-icon text-icon-success self-center shrink-0" />
				{{ plan.FormLimit === 0 ? 'Unlimited' : plan.FormLimit.toLocaleString() }} forms
			</li>
			<li class="flex items-baseline gap-3 mb-3">
				<Inline svg="check" class="w-icon h-icon text-icon-success self-center shrink-0" />
				{{ plan.EntryLimit === UNLIMITED_ENTRY_LIMIT ? 'Unlimited' : plan.EntryLimit.toLocaleString() }} entries{{ plan.EntryLimit === UNLIMITED_ENTRY_LIMIT ? '' : ' / mo.' }}
			</li>
			<li class="flex items-baseline gap-3 mb-3">
				<Inline svg="check" class="w-icon h-icon text-icon-success self-center shrink-0" />
				Accept payments
			</li>
			<li class="flex items-baseline gap-3 mb-3">
				<Inline svg="check" class="w-icon h-icon text-icon-success self-center shrink-0" />
				{{ plan.StorageLimitText }} of storage
			</li>
		</ul>
	</div>
</template>

<script lang="ts">
	import { defineComponent, type PropType } from 'vue';
	import type { Plan } from '@cognitoforms/types/server-types/plans/model/plan';

	// Plans store an unlimited entry allowance as C# Int32.MaxValue rather than 0.
	const UNLIMITED_ENTRY_LIMIT = 2 ** 31 - 1;

	export default defineComponent({
		name: 'PlanSummaryCard',
		props: {
			plan: {
				type: Object as PropType<Plan>,
				required: true
			},
			isAnnual: {
				type: Boolean,
				default: false
			},
			annualMonthlyPrice: {
				type: Number,
				default: 0
			}
		},
		setup() {
			return { UNLIMITED_ENTRY_LIMIT };
		}
	});
</script>
